export default __webpack_public_path__ + "static/media/partners-logo-chungnam-w.47bff0d0.webp";